<div class="trustpilot {{class}} {{version}}" [ngClass]="{'db-trustpilot-with-number': showNumber, 'show-services': showServices}">
  <div class="trustpilot_services" *ngIf="showServices && !showNumber">
    <img src="assets/images/logos/services/g2_FI_2020.svg" alt=""/>
    <img src="assets/images/logos/services/g2_HP_2021.svg" alt=""/>
  </div>
  <div class="active_users mb14" *ngIf="showNumber">
    <p><b>80K+</b> active users</p>
    <div class="wp_img_container">
      <img class="db-wp-logo" src="assets/images/logos/services/wp.svg" alt="">
    </div>
  </div>
  <ng-container *ngTemplateOutlet="selectedVersion"></ng-container>
</div>


<ng-template #microCombo>
  <!-- TrustBox widget - Micro Combo -->
  <div #trustbox  class="trustpilot-widget" data-locale="en-US" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="5da032d65a294d00014a14c3" data-style-height="20px" data-style-width="100%">
    <a href="https://www.trustpilot.com/review/10web.io" target="_blank" rel="noopener">Trustpilot</a>
  </div>
  <!-- End TrustBox widget -->
</ng-template>


<ng-template #microStar>
  <!-- TrustBox widget - Micro Star -->
  <div #trustbox  class="trustpilot-widget" data-locale="en-US" data-template-id="5419b732fbfb950b10de65e5"
       data-businessunit-id="5da032d65a294d00014a14c3" data-style-height="22px" data-style-width="267px">
    <a href="https://www.trustpilot.com/review/10web.io" target="_blank" rel="noopener">Trustpilot</a>
  </div>
  <!-- End TrustBox widget -->
</ng-template>
